import React, { useEffect, useState, useCallback, useRef, useContext } from 'react';
import { useGlobalEnvConfig } from "@environment/GlobalEnvConfigProvider";
import { safeImageUrl } from '@utils/Utils';
import { TemplateData } from '@App';

import './style.scss';

const BlurredBackdrop = ({ image, customClass = "", alt = "", isStatic = false, onImageLoad }) => {
    const { REACT_APP_RESOURCE_DOMAIN } = useGlobalEnvConfig();
    const [imageUrl, setSafeImageUrl] = useState("")
    const [imageSrcSet, setImageSrcSet] = useState("")
    const [backgroundLoaded, setBackgroundLoaded] = useState(false)
    const [foregroundLoaded, setForegroundLoaded] = useState(false)
    const onImageLoadRef = useRef(onImageLoad);

    const templateData = useContext(TemplateData);

    useEffect(() => {
        onImageLoadRef.current = onImageLoad;
    }, [onImageLoad]);

    useEffect(() => {
        if (image) {
            if (!isStatic) {
                const url = safeImageUrl(REACT_APP_RESOURCE_DOMAIN, image.UrlFragment, image.Default.Width, image.Default.Height, image.Default.Mode, image.Default.QueryString);
                setSafeImageUrl(url);

                const srcSet = `${image.Alternates.map(x => `${safeImageUrl(REACT_APP_RESOURCE_DOMAIN, image.UrlFragment, x.Width, x.Height, x.Mode, x.QueryString)} ${x.Width}w`).join(', ')}, ${url} ${image.Default.Width}w`;
                setImageSrcSet(srcSet);
            } else {
                setSafeImageUrl(image.UrlFragment);
                setImageSrcSet(`${image.UrlFragment} 1x, ${image.UrlFragment} 2x`);
            }
        }
    }, [image, REACT_APP_RESOURCE_DOMAIN, isStatic])

    useEffect(() => {
        if (backgroundLoaded && foregroundLoaded && onImageLoadRef.current) {
            onImageLoadRef.current();
        }
    }, [backgroundLoaded, foregroundLoaded]);

    const handleBackgroundLoad = useCallback(() => {
        setBackgroundLoaded(true);
    }, []);

    const handleForegroundLoad = useCallback(() => {
        setForegroundLoaded(true);
    }, []);

    return (
        <>
            {imageUrl &&
                <div className={`blurred-image-wrapper ${customClass}`}>
                    <img
                        src={imageUrl}
                        alt=""
                        className="blurred-background"
                        style={{ filter: templateData.ImageBlur ? `blur(${templateData.ImageBlur}px)` : 'none' }}
                        onLoad={handleBackgroundLoad}
                    />
                    <img
                        alt={alt}
                        className={(image.imageCredit || image.imageDesc || image.imageLabel) ? `swiper-lazy main-image has-info ${customClass}` : `swiper-lazy main-image ${customClass}`}
                        src={imageUrl}
                        srcSet={imageSrcSet}
                        onLoad={handleForegroundLoad}
                    />
                </div>
            }
        </>
    );
};

export default BlurredBackdrop;
